import { isZH } from "../locale";
// todo: 版本号
import moment from "moment";

export const getText = (
  text?: IMultiElementCombineMsg.IText | string | undefined
): string => {
  if (!text) return "";
  if (typeof text === "string") return text;
  const { zh_cn = "", en_us = "" } = text?.i18n || {};
  // 中英文互相兜底
  return isZH() ? zh_cn || en_us : en_us || zh_cn;
};

export const getNumOfHourMin = (time = "00:00") => {
  const t = time.split(":");
  return [+t[0], +t[1]];
};

/**
 * eg: 1613986831 -> '17:40'
 * @param {时间戳（秒）} time
 * @param {转换的格式} format
 */
export const getFormatByMill = (time, format = "HH:mm") =>
  moment.unix(time).format(format);

/**
 * 获取这一天的起始时间戳,返回值为字符串类型
 * eg: 1612704600(2021-02-07 21:30:00) -> '1612627200'(2021-02-07 00:00:00)
 * @param {时间戳（秒）} time
 */
export const getStartTimeOfDayByMill = (time) => {
  const stamp = moment.unix(time).startOf("day").format("X");
  return +stamp;
};

export const getRangArr = (start, end) => {
  const result: number[] = [];
  for (let i = start; i < end + 1; i++) {
    result.push(i);
  }
  return result;
};

/**
 * @description 获取当前时间的整分钟时间戳
 */
export const getWholeMins = (stamp) => {
  if (!stamp) return 0;

  return +stamp - (+stamp % 60);
};
